import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import AsszociaciosKerdesEditDto from 'app/admin/asszociacioskerdes/dto/AsszociaciosKerdesEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class AsszociaciosKerdesEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'asszociaciosLeirasEditControl';
	}

	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new AsszociaciosKerdesEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new AsszociaciosKerdesEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	update(id, dto) {
		console.log(dto);
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/*getKerdesAsszoc(asszociaciosLeirasId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/asszociaciosKerdesEditControl/getKerdesAsszoc`, {
					asszociaciosLeirasId
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}*/

	getLeirasTetel(asszociaciosLeirasId) {
		if ( asszociaciosLeirasId === "new" ) asszociaciosLeirasId = null;
		// console.log("asszociaciosLeirasId: " + asszociaciosLeirasId);
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/asszociaciosLeirasTetelEditControl/getLeirasTetel`, {
					asszociaciosLeirasId
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new AsszociaciosKerdesEditService();
